import React, { useRef, useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { LEFTRIGHT_PADDING } from "../config/style.config";
import { postTemplateDocument, postCreatePermit, postPermitHistory, putEditPermit, fetchPermitById, fetchPermitHistory } from '../services/permit.service';
import { isNewPermitSystemWithSigniture } from '../config';
//svg
import TitleLeftSvg from '../svgs/TitleLeftSvg'
import BluePlus from '../svgs/permit/BluePlus'
import SmallHeader from '../svgs/tracking/SmallHeader'
//componets
import GenerateForm from '../components/permit/display/GenerateForm';
import FormStatus from '../components/permit/display/FormStatus';
import Loading from '../components/Loading'
import PermitActivityLog from '../components/permit/PermitActivityLog';
import { getDateOnly } from '../actions/actionsDateTime'
import { deleteFileByName } from '../services/httpApiTracking';
import html2canvas from 'html2canvas'
import { jsPDF } from "jspdf";
import LoadingPage from '../components/Loading';
import { THEMES } from '../dto/theme';
function Screen(props) {
    const navigate = useNavigate();
    const param = useLocation()
    const URLParam = useParams()
    const currentUserId = props.control.userData._id
    if (!param.state?.data && !URLParam._id) navigate('/permit')
    const [templateData, setTemplateData] = useState(param?.state?.data)
    const [formData, setFormData] = useState(param?.state?.data?.form)
    const [copyTemplate, setCopyTemplate] = useState({ ...param?.state?.data })
    const [editedObj, setEditedObj] = useState({})
    const [attachments, setAttachements] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [pageToggle, setPageToggle] = useState('Overview')
    const [userIsIssuer, setIsUserIssuer] = useState(undefined)
    const [userIsApprover, setIsUserApprover] = useState(undefined)
    const [userIsReceiver, setIsUserReceiver] = useState(undefined)
    const [hasPermission, setHasPermission] = useState(false)
    const [errorMsg, setErrorMsg] = useState('')
    const [saveSignature, setSaveSignature] = useState('')
    const handleSaveSignature = (url) => setSaveSignature(url)
    const [issuerSign, setIssuerSign] = useState(false)

    const handleSetIssuerSign = async (val) => {
        if(!URLParam._id) return alert('Save First')
        setIssuerSign(val)
        // const history = {
        //     issuerSignature: saveSignature
        // }
        // const createFirst = await handlePostHistory(history, URLParam._id)
        // setTemplateData(prev => {return {...prev, status: 'Pending for approval'}})
    }

    useEffect(() => {
        if (issuerSign) {
            sumbitData()
        }
    }, [issuerSign])

    useEffect(() => {
        console.log(templateData)
        // console.log(editedObj)
        // console.log(saveSignature)
    }, [templateData, editedObj,saveSignature])
    useEffect(() => {
        if (props.control.userData?._id && templateData?.createdBy && !hasPermission) {
            const issuerPermission = props.control.userData._id === templateData?.createdBy
            const approvePermission = (templateData?.approvers || []).some((obj) => obj.username === props.control.userData.username)
            const viewPermission = (templateData?.viewers || []).some((obj) => obj.username === props.control.userData.username)
            //viwer is the approver array
            // console.log({issuerPermission, approvePermission, viewPermission})
            setIsUserIssuer(issuerPermission)
            setIsUserApprover(approvePermission)
            setIsUserReceiver(viewPermission)
            const havePerm = [issuerPermission, approvePermission, viewPermission].some((perms) => perms === true)
            // if(!havePerm) navigate('/permit')
            setHasPermission(havePerm)
        }
    }, [props.control.userData, templateData])
    useState(async () => {
        let temp = { ...templateData }
        if (URLParam._id) {
            const newTemplateData = await fetchPermitById(props.token.token, URLParam._id)
            if (newTemplateData.errno) return navigate('/permit')
            temp = { ...newTemplateData.result }
        }
        delete temp.createDate
        delete temp.modifiedBy
        delete temp.modifyDate
        delete temp.createBy
        temp.template_id = temp._id
        temp.templateName = temp?.name || temp?.templateName
        temp.templateType = temp?.type || temp?.templateType
        if(!temp.status)temp.status = 'Draft'
        if (!temp.approvers) temp.approvers = []
        if (!temp.receivers) temp.receivers = []
        if (!temp.viewers) temp.viewers = []
        temp.newAttachments = []
        temp.newDelete = []
        // console.log(temp)
        setCopyTemplate(JSON.parse(JSON.stringify(temp)))
        setTemplateData(temp)
        setFormData(temp.form)
    }, [])
    function handleSubmitError(msg) {
        setErrorMsg(msg)
        setIsLoading(false)
    }
    function isRequiredFilled(form){
        let isValid = true
        form.forEach((section, idx) => {
            if(!section?.isCancelRequiredSection){
                section.data.forEach((field, fIdx) => {
                    if(field.required){
                        if(field.type === 'Text input' || field.type === 'Date'){
                            if((typeof field.fieldData.data !== 'string' || !field.fieldData.data)) isValid = false
                        }
                    }
                })
            }
        })
        return isValid
    }
    function isCancelledFilled(form){
        let isValid = true
        form.forEach((section, idx) => {
            if(section?.isCancelRequiredSection){
                section.data.forEach((field, fIdx) => {
                    if(true){
                        if(field.type === 'Text input' || field.type === 'Date'){
                            if((typeof field.fieldData.data !== 'string' || !field.fieldData.data)) {
                                console.log(field.fieldData)
                                isValid = false
                            }
                        }
                    }
                })
            }
        })
        return isValid
    }
    async function sumbitData() {
        setIsLoading(true)
        const finalData = { ...templateData }
        finalData.form = [...formData]
        // return compareForHistory(finalData)
        // if(isNewPermitSystemWithSigniture &&  param.state.signature){
        //     if(!saveSignature) return handleSubmitError('Please select a signature')
        //     if(!issuerSign) return handleSubmitError('Please sign')
        // }
        if (finalData.attachments === undefined) finalData.attachments = []
        if (finalData.isAllApprovers === undefined) finalData.isAllApprovers = false
        if (finalData?.status === undefined) return handleSubmitError('Pick a status');
        if (finalData.validFrom === undefined || finalData.validTo === undefined) return handleSubmitError('Input valid time');
        if (!finalData.validFrom instanceof Date && !isNaN(finalData.validFrom)) return handleSubmitError('invalid validFrom date formate')
        if (!finalData.validTo instanceof Date && !isNaN(finalData.validTo)) return handleSubmitError('invalid validTo date formate')
        //
        delete finalData._id
        delete finalData.type
        const copyNewAttachement = [...finalData.newAttachments]
        finalData.attachments = [...finalData.attachments, ...finalData.newAttachments]
        delete finalData.newAttachments
        let permitRes
        if (finalData.newDelete.length > 0) {
            finalData.newDelete.forEach(async ({ id, type }) => {
                const res = await deleteFileByName(props.token.token, id + '.' + type.split('/')[1])
            })
        }
        delete finalData.newDelete
        delete finalData.createdById
        delete finalData.createdByUser
        delete finalData.createdBy
        if (URLParam._id) {
            delete finalData.templateName
            delete finalData.templateType
            delete finalData.projectId
            delete finalData.template_id
            if(isNewPermitSystemWithSigniture && issuerSign && finalData.status === 'Draft'){
                // const isAllFilled = isRequiredFilled(finalData.form)
                // if(!isAllFilled) return alert('Missing Required fields')
                finalData.status = 'Pending for approval'
            }
            const everyApprove = finalData.approvers.every(obj => obj.isApproved === 1)
            const everyCancelled = finalData.approvers.every(obj => obj.isApproved === -2)
            if(finalData.approvers.length && everyApprove) finalData.status = 'Approved'
            if(finalData.approvers.length && everyCancelled){
                const isAllFilled = isCancelledFilled(finalData.form)
                if(!isAllFilled) {
                    setIsLoading(false)
                    return alert('Missing Required fields')
                }
                finalData.status = 'Cancelled'
            }


            permitRes = await putEditPermit(props.token.token, finalData, templateData._id)
            let history = {}
            const histroy2 = compareForHistory(finalData)
            if(isNewPermitSystemWithSigniture && issuerSign && saveSignature){
                history.issuerSignature = saveSignature
                if(props.control.userData.data.firstname || props.control.userData.data.lastname){
                    history.issuerSignature = history.issuerSignature + '||' + (props.control.userData.data.firstname || '') + ' ' + (props.control.userData.data.lastname || '')
                }
                // history.status = 'Pending for approval'
            }
            history = {...history, ...histroy2}
            const historyRes = await handlePostHistory(history)
        } else {
            permitRes = await postCreatePermit(props.token.token, finalData)
            // console.log('this is permit res',permitRes)
            const history = {created: ''}
            const createFirst = await handlePostHistory(history, permitRes.result.insertedId)
        }
        if (permitRes.errno) return console.log(permitRes)
        //
        // console.log('copy new Attach', copyNewAttachement)
        if (copyNewAttachement.length > 0) {
            let i = 0
            for (const file of attachments.entries()) {
                const id = copyNewAttachement[i].id
                const type = copyNewAttachement[i].type
                const res = await postTemplateDocument(props.token.token, file, id, type)
                if (res.errno) return console.log(res)
                i++
            }
        }

        setIsLoading(false)
        navigate('/permit')
    }
    function handleHaveAttachement(formData) {
        setAttachements(formData)
    }
    function updateFieldDataDataWithKey(i, k, val) {
        const temp = [...formData]
        const newEditedObj = { ...editedObj }
        const title = temp[i].data[k].fieldData.title === undefined ? temp[i].data[k].fieldData.textInputTitle : temp[i].data[k].fieldData.title
        const newKey = `Section${i + 1}_${temp[i].data[k].type}_${title}`
        newEditedObj[newKey] = [val]
        temp[i].data[k].fieldData.data = val
        setEditedObj(newEditedObj)
        setFormData(temp)
    }
    function updateFieldData(i, k, val) {
        const temp = [...formData]
        const newEditedObj = { ...editedObj }
        const type = temp[i].data[k].type
        const newKey = `Section${i + 1}_${type}_field${k + 1}`
        newEditedObj[newKey] = 'Updated value'

        temp[i].data[k].fieldData = val
        setEditedObj(newEditedObj)
        setFormData(temp)
    }
    function handleDeleteExistingFile(obj) {
        const temp = { ...templateData }
        const copy = [...templateData.attachments]
        const final = copy.filter(({ id, type }) => id !== obj.id)
        const deleteArr = copy.filter(({ id, type }) => id === obj.id)
        const newDelete = [...templateData.newDelete, ...deleteArr]
        temp.newDelete = newDelete
        temp.attachments = final
        //
        const newEditedObj = { ...editedObj }
        const type = 'remove_attachment'
        const newKey = `${type}_${obj.id + '.' + obj.type.split('/')[1]}`
        newEditedObj[newKey] = ''
        setEditedObj(newEditedObj)
        setTemplateData(temp)
    }
    function updateTemplateDataWithKey(key, val) {
        const temp = { ...templateData }
        const newEditedObj = { ...editedObj }
        const newKey = `Permit_${key}`
        if (['validFrom', 'validTo'].includes(key)) {
            newEditedObj[newKey] = [getDateOnly(val)]
        }
        temp[key] = val
        if (key === 'newAttachments') {
            const type = 'permit_newAttachement'
            newEditedObj[type] = ''
        }
        setEditedObj(newEditedObj)
        setTemplateData(temp)
    }
    async function handlePostHistory(obj, whenCreate = null) {
        const data = {}
        data.permit_id = templateData._id
        if (whenCreate) data.permit_id = whenCreate
        data.data = obj
        const res = await postPermitHistory(props.token.token, data)
    }
    function compareForHistory(newObj) {
        const historyObj = { ...editedObj }
        if (copyTemplate.status !== newObj.status) {
            historyObj.status = templateData.status
        }
        const usersAll = ['approvers', 'receivers', 'viewers']
        console.log(copyTemplate, newObj)
        usersAll.forEach(key => {
            const idToApprove = {}
            const ogUser = copyTemplate[key].map(obj => {
                if (key === 'approvers') idToApprove[obj.username] = obj.isApproved
                if (key === 'receivers') idToApprove[obj.username] = obj.isRead
                return obj.username
            })
            console.log(idToApprove)
            const userSet = new Set(ogUser)
            // console.log(idToApprove, userSet)
            newObj[key].forEach(obj => {
                if (!userSet.has(obj.username)) {
                    const objKey = 'added_' + key
                    historyObj[objKey] ? historyObj[objKey].push(obj.username) : historyObj[objKey] = [obj.username]
                } else {
                    if (key === 'approvers') {
                        console.log(idToApprove, obj, idToApprove[obj.username] !== obj.isApproved)
                        if (idToApprove[obj.username] !== obj.isApproved) {
                            if(obj.isApproved === -2){
                                historyObj.newlyCancelled ? historyObj.newlyCancelled.push(obj.username) : historyObj.newlyCancelled = [obj.username]
                            }else if(obj.isApproved === 0){
                                historyObj.newlyDelined ? historyObj.newlyDelined.push(obj.username) : historyObj.newlyDelined = [obj.username]
                            }else{
                                historyObj.newlyApproved ? historyObj.newlyApproved.push(obj.username) : historyObj.newlyApproved = [obj.username]
                            }
                        }
                    }
                    if (key === 'receivers') {
                        if (!idToApprove[obj.username] === obj.isRead) {
                            historyObj.newlyRead ? historyObj.newlyRead.push(obj.username) : historyObj.newlyRead = [obj.username]
                        }
                    }
                    userSet.delete(obj.username)
                }
            })
            const remaining = Array.from(userSet)
            if (remaining.length > 0) {
                remaining.forEach((user) => {
                    const newKey = 'removed_' + key
                    historyObj[newKey] ? historyObj[newKey].push(user) : historyObj[newKey] = [user]
                })
            }
        })
        console.log(historyObj)
        return {
            data: historyObj
        }
    }
    // compareForHistory(templateData)
    function handleUpdateRoles(type, obj) {
        const currentList = [...templateData[type]]
        let targetDeleteIdx = undefined
        const inCurrentList = currentList.some((currObj, idx) => {
            const result = currObj.username === obj.username
            if (result) targetDeleteIdx = idx
            return result
        })
        if (inCurrentList) {
            currentList.splice(targetDeleteIdx, 1)
            if (type === 'approvers') {
                let isAllApproved = currentList.every((approverObj) => approverObj.isApproved === 1)
                if (isAllApproved && currentList.length > 0)
                    updateTemplateDataWithKey('status', 'Approved')
            }
        } else {
            let tempObj = undefined
            if (type === 'approvers') tempObj = { username: `${obj.username}`, isApproved: -1 }
            // if(type === 'approvers' && isNewPermitSystemWithSigniture && (obj.data?.firstName || obj.data?.lastName)){
            //     tempObj.username = `${tempObj.username}`
            // }
            if (type === 'viewers') tempObj = { username: obj.username }
            currentList.push(tempObj)
        }
        updateTemplateDataWithKey(type, currentList)
    }
    const divToPrintRef = useRef(null)
    const downloadReport = async () => {
        if (isLoading) return
        setIsLoading(true)
        let doc = new jsPDF('p', 'mm', 'a4', true);

        let page = 1;
        const arr = []

        const d = divToPrintRef.current;

        const canvas = await html2canvas(d, { useCORS: true, allowTaint:false  })
        const img = canvas.toDataURL('image/png');

        console.log('generated image for page: ', page)
        const imgWidth = 210;
        const pageHeight = 295;
        const imgHeight = canvas.height * imgWidth / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;
        arr.push([img, 'PNG', 0, position, imgWidth, imgHeight])

        heightLeft -= pageHeight;
        while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            arr.push([img, 'PNG', 0, position, imgWidth, imgHeight])
            heightLeft -= pageHeight;
        }

        page++

        for (let i in arr) {
            doc.addImage(arr[i][0], 'PNG', 0, arr[i][3], arr[i][4], arr[i][5], i, .5);
            if (i != (arr.length - 1))
                doc.addPage();
        }

        doc.save('permit.pdf');
        setIsLoading(false)
    };
    const isLockPermit = useMemo(() => {
        if(isNewPermitSystemWithSigniture){
            return templateData.status === 'Approved'
        }
        return templateData.status === 'Pending for approval'
    },[templateData])


    return (
        <div className='w-full h-full pb-12' style={{ overflowY: 'auto', filter: props.control.theme === THEMES.DARK ? 'none' : 'invert(1)', color: props.control.theme === THEMES.DARK ? '#FFFFFF' : '#000000', backgroundColor: props.control.theme === THEMES.DARK ? '#0C0D14' : '#FFFFFF' }}>
            {isLoading && <div className='select-none opacity-40 w-[100vw] h-[100vh] fixed inset-0 bg-[#000000] flex flex-row items-center justify-center' style={{ zIndex: 99 }}>
                <Loading />
            </div>}
            <div style={{ ...LEFTRIGHT_PADDING, backgroundColor: props.control.theme === THEMES.DARK ? '#0C0D14' : '#FFFFFF' }} className='flex flex-col' ref={divToPrintRef}>
                <div className="flex flex-col justify-between items-center text-white">
                    <div className="flex flex-row items-center justify-between mt-[40px] w-full flex-wrap">
                        <div className='flex flex-row items-center flex-1 min-w-[300px]'>
                            <TitleLeftSvg className='mr-[9px]' />
                            <div className="text-[24px] font-bold flex-1" style={{ color: props.control.theme === THEMES.DARK ? '#FFFFFF' : '#000000' }}>
                                Preview - {templateData?.templateName}<span className='text-[14px]' style={{ color: props.control.theme === THEMES.DARK ? '#949494' : 'black' }}> | {templateData?.type || templateData?.templateType}</span>
                            </div>
                        </div>

                        <div className='flex flex-row items-center justify-center gap-4 flex-wrap'>
                            <div onClick={() => navigate('/permit')} className='py-[2px] px-[16px] text-white rounded-full select-none cursor-pointer' style={{ backgroundColor: props.control.theme === THEMES.DARK ? '#FFFFFF26' : '#000000' }}>
                                Cancel</div>
                            {(hasPermission || props.token?.usertype === 'admin') && <div onClick={() => { sumbitData() }} className='py-[2px] px-[16px] bg-[#00202A] text-[#63BDFF] rounded-full select-none cursor-pointer'>{URLParam._id ? 'Save Permit' : 'Create Permit'}</div>}
                        </div>
                    </div>
                    <div className='text-[red] ml-auto'>{errorMsg}</div>

                </div>
                <div className='w-full flex flex-row mt-[40px] flex-wrap gap-[16px]'>
                    <div className='flex-1'>
                        <div className='w-full flex flex-row'>
                            <div onClick={() => { setPageToggle('Overview') }} className='p-[8px] select-none cursor-pointer text-[16px] font-bold' style={pageToggle === 'Overview' ? { borderBottomWidth: 1, borderBottomColor: '#FFFFFF80', color: props.control.theme === THEMES?.DARK ? 'white' : 'black' } : { color: props.control.theme === THEMES?.DARK ? '#3F3F3F' :'grey' }}>Overview</div>
                            <div onClick={() => { setPageToggle('Activity Log') }} className='p-[8px] select-none cursor-pointer text-[16px] font-bold' style={pageToggle === 'Activity Log' ? { borderBottomWidth: 1, borderBottomColor: '#FFFFFF80', color: props.control.theme === THEMES?.DARK ? 'white' : 'black' } : { color: props.control.theme === THEMES?.DARK ? '#3F3F3F' :'grey' }}>Activity Log</div>
                        </div>
                        {pageToggle === 'Overview' && <div className='flex-1 max-w-[1500px] relative'>
                            <GenerateForm inPending={isLockPermit} permissionObj={{ userIsIssuer, userIsApprover, userIsReceiver }} form={formData} isPreview={false} updateFieldDataDataWithKey={updateFieldDataDataWithKey} updateFieldData={updateFieldData} />
                        </div>}
                        {(pageToggle === 'Activity Log' && URLParam._id) && <PermitActivityLog hasPermission={hasPermission || props.token?.usertype === 'admin'} handlePostHistory={handlePostHistory} _id={templateData._id} />}
                    </div>
                    <div className='flex-1 h-full py-[24px] px-[20px]' style={{ maxWidth: 'min(400px, 100%)' }}>
                        <FormStatus handleSetIssuerSign={handleSetIssuerSign} issuerSign={issuerSign} saveSignature={saveSignature} handleSaveSignature={handleSaveSignature} hasPermission={hasPermission || props.token?.usertype === 'admin'} handleUpdateRoles={handleUpdateRoles} handleDeleteExistingFile={handleDeleteExistingFile} handleHaveAttachement={handleHaveAttachement} templateData={templateData} updateTemplateDataWithKey={updateTemplateDataWithKey} isPreview={false} />
                    </div>
                </div>
                <div onClick={downloadReport} className='cursor-pointer underline mb-[20px]' style={{ padding: '4px 12px' }}>Download Permit</div>
            </div>
            {isLoading && <LoadingPage />}
        </div>
    )
}
export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Screen)